/* eslint-disable no-undef */
/**
 * Look one place up by free-text query.
 *
 * Resolves `{ place, status }` rather than a bare place. The status matters:
 * OVER_QUERY_LIMIT means Google is throttling us and the lookup should be
 * retried, while ZERO_RESULTS means the place genuinely was not found. Callers
 * used to receive plain `null` for both and treated throttling as a miss.
 */
export function resolvePlace(gmapApiPromiseLazy, query, options = {}) {
  const { fields = ['place_id', 'name', 'geometry', 'formatted_address', 'address_components'], sessionToken } = options;
  return new Promise((resolve) => {
    gmapApiPromiseLazy().then(() => {
      const autocompleteService = new google.maps.places.AutocompleteService();
      const predRequest = { input: query };
      if (sessionToken) predRequest.sessionToken = sessionToken;
      autocompleteService.getPlacePredictions(predRequest, (predictions, status) => {
        if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions || !predictions.length) {
          resolve({ place: null, status: String(status) });
          return;
        }

        const placeId = predictions[0].place_id;
        const placesService = new google.maps.places.PlacesService(document.createElement('div'));
        const detailRequest = { placeId, fields };
        if (sessionToken) detailRequest.sessionToken = sessionToken;
        placesService.getDetails(detailRequest, (place, detailStatus) => {
          if (detailStatus !== google.maps.places.PlacesServiceStatus.OK || !place) {
            resolve({ place: null, status: String(detailStatus) });
            return;
          }
          resolve({ place, status: 'OK' });
        });
      });
    }).catch((error) => resolve({ place: null, status: 'ERROR', error }));
  });
}
